<template>

    <div class="w-full md:w-1/3 md:pl-4">
        <div id="order-summary-link" class="goto-link-offet"></div>
        <div
            id="order-summary"
            :class="{
                'md:fixed': ! processing,
                'md:pb-8': sidebarHeight !== 'auto',
                'md:border': sidebarHeight !== 'auto',
                'md:overflow-y-scroll': sidebarHeight !== 'auto',
            }"
        >
            <div
                class="border md:border-0 p-8 bg-white"
                :class="{
                    'md:shadow-sau-lg': sidebarHeight === 'auto',
                }"
            >
                <order-summary :order="order" :data="data"></order-summary>
            </div>
            <div class="text-center mt-6">
                <img src="/img/geotrust.png" class="w-full" style="max-width: 7.5rem !important;">
                <small class="text-grey text-xs block">
                    Secure payments with GeoTrust 256-bit encryption
                </small>
            </div>
        </div>
    </div>

</template>
<script>
import Helpers from '@js/helpers';
import OrderSummary from './Summary';
export default {

    props: {
        data: Object,
        order: Object,
        processing: Boolean,
    },

    components: {
        OrderSummary,
    },

    data() {
        return {
            sidebarWidth: '100%',
            sidebarHeight: 'auto',
            validating: false,
        }
    },

    created() {

    },

    mounted() {
        this.setupSidebar();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.keepSidebarWithinView);
    },

    methods: {

        setupSidebar() {
            this.$nextTick(function() {
                window.addEventListener('resize', this.keepSidebarWithinView);
                this.keepSidebarWithinView();
            });
        },

        keepSidebarWithinView: function (event) {
            let bottomMargin = 16 * 5; // rems
            let element = document.querySelector('#order-summary');
            if (! element) {
                return;
            }
            let bounds = Helpers.outOfViewport(element);
            let innerHeightExceedsBounds = (element.scrollHeight + element.offsetTop) > window.innerHeight;

            if ((bounds.bottom || innerHeightExceedsBounds) && Helpers.screens().md) {
                this.sidebarHeight = `${window.innerHeight - element.offsetTop - bottomMargin}px`;
            } else {
                this.sidebarHeight = 'auto';
            }

            if (Helpers.screens().md) {
                let parentComputedStyle = window.getComputedStyle(element.parentElement);
                let xPaddingForParentElement = window.parseInt(parentComputedStyle.paddingLeft) + window.parseInt(parentComputedStyle.paddingRight);
                this.sidebarWidth = `${element.parentElement.clientWidth - xPaddingForParentElement}px`;
            } else {
                this.sidebarWidth = '100%';
            }

            // I don't know why this is being dumb...
            element.style = `
                width: ${this.sidebarWidth};
                min-width: ${this.sidebarWidth};
                max-width: ${this.sidebarWidth};
                max-height: ${this.sidebarHeight};
            `;
        },

    },

    watch: {
        order: function (val) {
            this.validating = false;
            this.$nextTick(() => {
                this.keepSidebarWithinView();
            });
        },
    },

}
</script>
